import companyApiServices from '../../api/company';
import cookies from '../../utils/cookies';

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export default {
  getMeCompany: async ({ state, commit }, { email = '', force = true }) => {
    let companyEmail = email
    if (companyEmail) {
      const token = cookies.getItem('token');
      const JWT = parseJwt(token);
      companyEmail = JWT.email
    }

    const key = companyEmail;
    const cachedCompanyEmail = state.cachedCompany[key];

    if (!force && cachedCompanyEmail) {
      commit('SET_COMPANY', cachedCompanyEmail);
      return cachedCompanyEmail;
    }

    const { data } = await companyApiServices.getMe({ email });
    if (!data) return [];
    const { company } = data;
    commit('SET_COMPANY', company);
    commit('CACHE_COMPANY', { key, company });

    return company;
  },
  getCompanies: async ({ state, commit }, { includeJobs = false, force = true }) => {
    const key = `companies&includeJobs=${includeJobs}`;
    const cachedCompanies = state.cachedCompanies[key];
    if (!force && cachedCompanies) {
      commit('SET_COMPANIES', cachedCompanies);
      return cachedCompanies;
    }

    const { data } = await companyApiServices.getAll({ includeJobs });
    if (!data) return [];
    const { companies } = data;
    commit('SET_COMPANIES', companies);
    commit('CACHE_COMPANIES', { key, companies });

    return data;
  },
  getCompanyById: async ({ state, commit }, { companyId, includeJobs, force = true }) => {
    const key = `company${companyId}&includeJobs=${includeJobs}`;
    const cachedCompanyById = state.cachedCompanyById[key];
    if (!force && cachedCompanyById) {
      commit('SET_COMPANY_BY_ID', cachedCompanyById);
      return cachedCompanyById;
    }

    const { data } = await companyApiServices.getById(companyId, { includeJobs });
    if (!data) return [];
    commit('SET_COMPANY_BY_ID', data);
    commit('CACHE_COMPANY_BY_ID', { key, company: data });

    return data;
  },
  cleanData: ({ commit }) => {
    commit('SET_COMPANY_BY_ID', {})
    commit('SET_COMPANY', {});
  },
};
